export default __webpack_public_path__ + "static/media/79.fee05205.png";